import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import CvPageLayout from '../../../components/CvPageLayout';
import EducationForm from '../../../components/EducationForm';

function CvEducationAdd() {
  const location = useLocation();
  const isEditing = !!location.state?.id; 

  return (
    <CvPageLayout currentStep="Edukacja">
      <Row className="justify-content-md-center mt-3">
        <Col>
          <EducationForm
            backlink="/cv-career/cv-generator/section/education"
            nextlink="/cv-career/cv-generator/section/education/description"
            title={isEditing ? 'Edytuj swoje wykształcenie' : 'Opowiedz nam o swoim wykształceniu'}
            subtitle={isEditing ? null : 'Dodaj wszystkie etapy edukacji, w tym te, które nadal trwają.'}
          />
        </Col>
      </Row>
    </CvPageLayout>
  );
}

export default CvEducationAdd;